var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDummies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 125,
    viewBox: "0 0 109 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9503 61.7578C41.8214 46.1312 64.9234 43.8975 80.5499 56.7686C96.1765 69.6398 98.4102 92.7417 85.5391 108.368L6.02705 204.902L-50.5617 158.292L28.9503 61.7578Z",
    fill: "#49B7E4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-11.4682 28.4663C1.40291 12.8397 24.5049 10.606 40.1314 23.4771C55.758 36.3483 57.9917 59.4502 45.1206 75.0768L-34.3914 171.611L-90.9802 125L-11.4682 28.4663Z",
    fill: "#AFD34F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummies);
export default __webpack_public_path__ + "static/media/dummies.870b1442fbd5a6bfe6fa9e7494fdc695.svg";
export { ForwardRef as ReactComponent };